<template>
  <div>
    <div class="filter-section-header">sort</div>
    <v-btn-toggle mandatory rounded :value="projectSort" @change="handleChange">
      <v-btn class="sort-btn">Latest</v-btn>
      <v-btn class="sort-btn">ABC</v-btn>
    </v-btn-toggle>
  </div>
</template>
<script>
// vuex
import { mapActions, mapGetters } from 'vuex'
// library
// internal
// components
export default {
  name: 'SearchFilterSortOptions',
  data() {
    return {}
  },
  computed: {
    ...mapGetters(['projectSort'])
  },
  watch: {},
  mounted() {},
  methods: {
    ...mapActions(['setProjectSort']),
    handleChange(v) {
      this.setProjectSort(v)
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-section-header {
  margin-bottom: 10px;
}

button {
  min-width: 100px !important;
}
</style>
